import * as React from 'react';

function SvgCloudHaze2Fill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8.5 2a5.001 5.001 0 014.905 4.027A3 3 0 0113 12H3.5A3.5 3.5 0 01.035 9H5.5a.5.5 0 000-1H.035a3.5 3.5 0 013.871-2.977A5.001 5.001 0 018.5 2zm-6 8a.5.5 0 000 1h9a.5.5 0 000-1h-9zM0 13.5a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z' />
		</svg>
	);
}

export default SvgCloudHaze2Fill;
